import { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { isValidEmail } from '../../utils/helper';
import { resetPassword } from '../../api/publicApis';
import { useSnackbar } from 'notistack';
import RequestDemoBtn from '../request-demo-btn';
import transportIcon from '../../assets/icons/login.png';

function ForgotPassword() {
  let navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { enqueueSnackbar } = useSnackbar();
  const [email, setEmail] = useState('');
  const [gCaptcha, setGCaptcha] = useState('');
  const [loading, setLoading] = useState(false);
  const [validating, setValidating] = useState(false);
  const handleRecaptchaChange = (value: any) => {
    setGCaptcha(value);
  };
  function actionHandle() {
    setValidating(true);
    if (isValidEmail(email) && gCaptcha !== '') {
      setLoading(true);
      resetPassword(email)
        .then((response) => {
          if (!response?.data?.is_error) {
            setLoading(false);
            enqueueSnackbar('Request has been sent', {
              variant: 'success',
            });
          }
        })
        .catch((e) => setLoading(false));
    }
  }
  return (
    <>
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}
      <div className='row h-100   w-100 m-0'>
        <div className='col-sm-12 col-md-12 col-lg-6 my-auto text-center d-none d-lg-block h-100'>
          <div className='p-5'>
            <div className='row d-flex align-items-center justify-content-center'>
              <div className='col-12'>
                <img
                  className='mx-auto img-fluid'
                  src={transportIcon}
                  alt='ubbe computer'
                />
              </div>
              <div
                className=' col-12 lex-20-400 text-center mt-1'
                style={{ width: '424px' }}
              >
                “Access an unparalleled network of transportation partners”
              </div>
            </div>
            {/* <div className='row mt-4'>
              <div className='col-12'>
                <p>
                  Don't have a ubbe account yet?{' '}
                  <a className='text-decoration-none' href={'/sign-up'}>
                    Create one now!
                  </a>
                </p>
              </div>
            </div> */}
          </div>
        </div>
        <div className='col-sm-12 col-md-12 col-lg-6 bg-main min-vh-100'>
          <div className='w-100   h-100'>
            <div className=' d-flex align-items-center justify-content-center justify-content-lg-start ms-5 h-100'>
              <div>
                <div className='mb-4'>
                  <h2 className='text-white lex-48-700'>Forgot Password</h2>
                </div>
                <div className='d-flex flex-column align-items-center justify-content-start mb-3'>
                  <label
                    htmlFor='username'
                    className='form-label  color-white align-self-start lex-18-400 mb_0'
                  >
                    Email <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='text'
                    className='form-control ubbe-input'
                    style={{ width: '503px' }}
                    id='email'
                    name='email'
                    placeholder='Email'
                    maxLength={100}
                    value={email}
                    onChange={(e: any) => {
                      setEmail(e.target.value);
                    }}
                  />
                  {validating && !isValidEmail(email) && (
                    <div className='error_text'>
                      {'Please provide a valid email.'}
                    </div>
                  )}
                </div>
                <div className='row mt-4'>
                  <div className='w-100'>
                    <ReCAPTCHA
                      sitekey='6LcOjrwUAAAAAPZaVEOWj-KCIkwA35unMmY04lOL'
                      onChange={handleRecaptchaChange}
                    />
                    {validating && gCaptcha === '' && (
                      <div className='error_text'>Please verify.</div>
                    )}
                  </div>
                </div>

                <div className='row mb-1' style={{ marginTop: '20px' }}>
                  <div className='col-md-12'>
                    <button
                      onClick={actionHandle}
                      className='btn btn-ubbe-green rounded-5 p-2 w-100 lex-18-400'
                      id='find-out-more-benefits'
                    >
                      Reset Password
                    </button>
                  </div>
                  {/* <div className='col-md-6 my-auto'>
                    <a
                      className='text-decoration-none grey'
                      href={'/reset_password'}
                    >
                      Forgot password?
                    </a>
                  </div> */}
                </div>
                <div className='text-center text-white divider'>or</div>
                <div className='row mb-3 mt-1'>
                  <div className='col-md-12'>
                    <Link to={'/login'} className='text-decoration-none'>
                      <button
                        className='btn btn-ubbe-gray rounded-5 p-2 w-100 lex-18-400'
                        id='find-out-more-benefits'
                      >
                        Retry Login
                      </button>
                    </Link>
                  </div>
                  {/* <div className='col-md-6 my-auto'>
                    <a
                      className='text-decoration-none grey'
                      href={'/reset_password'}
                    >
                      Forgot password?
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='position-relative'>
          <div className='back-to-site-button'>
            <button
              className='btn-ubbe-gray rounded-5'
              onClick={() => {
                const url = process.env.REACT_APP_MAIN_URL;
                if (url) {
                  window.location.href = url;
                }
              }}
            >
              {' '}
              <span className=''>
                <svg
                  width='17'
                  height='12'
                  viewBox='0 0 17 12'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M13.8631 7.45448C14.7979 8.34944 15.2522 9.56528 15.2522 11.1723C15.2522 11.4373 15.4673 11.6523 15.7322 11.6523C15.9972 11.6523 16.2122 11.4399 16.2122 11.175C16.2122 9.31832 15.6454 7.83656 14.527 6.7664C11.9407 4.29152 7.06368 4.5104 3.14568 4.68272C2.59848 4.70696 2.07504 4.73336 1.58592 4.74992L5.1684 1.16696C5.35584 0.979517 5.35584 0.675676 5.1684 0.488236C4.98096 0.300796 4.67688 0.300796 4.48968 0.488236L0.14064 4.83776C0.0506401 4.92776 0 5.04992 0 5.17712C0 5.30432 0.0506401 5.42648 0.14064 5.51648L4.49016 9.86528C4.584 9.95912 4.70664 10.0059 4.82952 10.0059C4.9524 10.0059 5.07528 9.95912 5.16912 9.86528C5.35656 9.67784 5.35656 9.37376 5.16912 9.18656L1.73976 5.75816C2.19936 5.73176 2.68344 5.69552 3.18768 5.6732C6.72624 5.51768 11.573 5.26328 13.8631 7.45448Z'
                    fill='black'
                  />
                </svg>
              </span>{' '}
              Back to Website
            </button>
          </div>
        </div>
      </div>
      {/* <RequestDemoBtn /> */}
    </>
  );
}

export default ForgotPassword;
